import React, { useState, useEffect, useContext } from 'react'

import getUrl from 'lib/url'
import createFetch from 'lib/fetch-with-timeout'
import { useCityName } from 'Components/hooks'

// 天幕广告
import TianmuAd from './tianmu'
// 通栏广告
import TonglanAd from './tonglan-1'
// 炫景广告
import XuanjingAd from './xuanjing'
//  弹窗广告
import PopUpAd from './popUp'

import { isClosed } from './close'
import { isPast } from './past_24'
import { HomeStoreContext } from '../context'
import { AdData, AdResult } from './interface'

const fetch = createFetch({
  timeout: 5000,
})
export default function BannerAD() {
  const { dispatch } = useContext(HomeStoreContext)
  const [adInfo, setAdInfo] = useState<AdData>()
  const [showPopUp, setShowPopUp] = useState(false)
  const cityName = useCityName()
  useEffect(() => {
    if (typeof cityName !== 'undefined') {
      fetch(
        `/motor/ad/m/pc/banners?city_name=${encodeURIComponent(cityName)}`,
        {
          credentials: 'include',
        }
      )
        .then(res => res.json())
        .then((data: AdResult) => {
          if (data.status !== 0 || !data.data) {
            // 没有广告数据
            dispatch({
              type: 'setAdData',
              payload: null,
            })
            return
          }
          setAdInfo(data.data)
          dispatch({
            type: 'setAdData',
            payload: data.data,
          })
        })
        .catch(err => {
          console.error('fetch ad error')
          // 没有广告数据
          dispatch({
            type: 'setAdData',
            payload: null,
          })
          throw err
        })
    }
  }, [cityName, dispatch])

  // 弹窗广告需要等带炫景广告以及天幕广告之后再展示
  useEffect(() => {
    if (!adInfo) {
      return
    }
    let waitTime = 0
    if (adInfo.sky_fall_banner_ad || adInfo.dazzling_banner_ad) {
      waitTime = 5000
    }
    setTimeout(() => {
      const showPop =
        adInfo.main_splash_ad &&
        (!isClosed('popUp', adInfo.main_splash_ad.id_str) ||
          isPast('popUp', adInfo.main_splash_ad.id_str))
      setShowPopUp(showPop)
    }, waitTime)
  }, [adInfo])

  if (!adInfo) return null
  // 是否显示炫景广告
  const showXuanjingAd = adInfo.dazzling_banner_ad
  const showTianmuAd = adInfo.sky_fall_banner_ad
  const showTonglanAd =
    adInfo.pc_common_banner_ad &&
    !isClosed('tonglan', adInfo.pc_common_banner_ad.id_str)

  return (
    <>
      {showXuanjingAd &&
        Object.keys(adInfo.dazzling_banner_ad).length !== 0 && (
        <XuanjingAd data={adInfo.dazzling_banner_ad} />
      )}
      {showTianmuAd && Object.keys(adInfo.sky_fall_banner_ad).length !== 0 && (
        <TianmuAd data={adInfo.sky_fall_banner_ad} />
      )}
      {showTonglanAd &&
        Object.keys(adInfo.pc_common_banner_ad).length !== 0 && (
        <TonglanAd data={adInfo.pc_common_banner_ad} />
      )}
      {showPopUp && Object.keys(adInfo.main_splash_ad).length !== 0 && (
        <PopUpAd data={adInfo.main_splash_ad} />
      )}
    </>
  )
}
